import React, {useEffect, useState} from 'react';
import {useClient,useAs2Client} from "../as2-onboarding-component/hooks/useClient";
import {useOktaAuth} from '@okta/okta-react';
import {
    Typography, Card, CardContent, Grid,
    Accordion, AccordionSummary, AccordionDetails, Box,
    FormControlLabel, Switch,FormControl,InputLabel
} from "@mui/material";
import CheckCircle from '@mui/icons-material/CheckCircle';
import Warning from '@mui/icons-material/Warning'
import RenderStatus from "../as2-communication-status-component/as2-summary-table/RenderStatus";
import {getDiffDays,getExpirationLabel,extractHostnamePort} from '../utils/index';

const As2TradePartnersMismatchCACerts = () => {

    const {oktaAuth} = useOktaAuth();
    const sterlingClient = useClient(oktaAuth.getAccessToken());
    const as2Client = useAs2Client(oktaAuth.getAccessToken());
    const [filteredCaCertProfiles, setFilteredCaCertProfiles] = useState([]);
    const [caCertProfiles, setCaCertProfiles] = useState([]);

    const gridStyles = {
        height: "100%"
    };

    const onChangeShowNotMatching=((event)=>{
        event.preventDefault();

        if (event.target.checked){
            setCaCertProfiles([...filteredCaCertProfiles]);
            const onlyNotMatching = filteredCaCertProfiles.filter((profile)=> {
                return !profile.matching;
            });

            setFilteredCaCertProfiles(onlyNotMatching);
        }else {
            setFilteredCaCertProfiles(caCertProfiles);
        }

    });


    useEffect(() => {

        const fetchValidateCertificate = async (hostname, port) => {
            return await as2Client.get(`api/certificates/https-cert-details?hostname=${hostname}&port=${port}`);
        };

        const fetchSterlingAs2ProfileData = async () => {
            return await sterlingClient.get('/B2BAPIs/svc/as2tradingpartners/?_include=as2Identifier%2CcaCertificate.certName%2CcaCertificate.certificateOrder%2CcaCertificate.goLiveDate%2CcaCertificate.notAfterDate%2CendPoint%2CidentityName%2CprofileName&_range=0-999&_sort=profileId&as2Identifier=&identityName=&profileName=');
        };

        fetchSterlingAs2ProfileData().then((response) => {
            const as2TradingPartners = response.data;

            const uniqueCerts = [...new Map(as2TradingPartners.map(cert =>
                [cert.caCertificate[0].certName, {...cert.caCertificate[0], ...extractHostnamePort(cert.endPoint)}])).values()];

            const profiles = uniqueCerts.map((item) => {
                item["profiles"] = as2TradingPartners.filter((profile) => {
                    return profile.caCertificate[0].certName === item.certName;
                });

                return item;
            });


            for (const profile of profiles) {

                fetchValidateCertificate(profile.hostname, profile.port).then((res) => {
                    profile["remoteCaCert"] = {...res.data, "found": true};
                    profile["matching"] = profile.remoteCaCert.goLiveDate === profile.goLiveDate &&
                        profile.remoteCaCert.notAfterDate === profile.notAfterDate &&
                        profile.remoteCaCert.principalName.toLowerCase().includes(profile.hostname.toLowerCase());
                    setFilteredCaCertProfiles((prevState) => {
                        return [...prevState, profile]
                    });

                }).catch((reason) => {
                    profile["remoteCaCert"] = {
                        "found": false,
                        "goLiveDate": "-",
                        "notAfterDate": "-",
                        "principalName": ""
                    };
                    profile["matching"] = false;
                    setFilteredCaCertProfiles((prevState) => {
                        return [...prevState, profile]
                    });
                });
            }

        }).catch((reason) => {
            console.warn(reason);
        })
    }, []);

    return (


        <Grid container spacing={2} sx={{...gridStyles}}>
            <Grid container item alignItems="flex-start">
                <Typography gutterBottom variant="h1" component="h1">
                    Trading Partners - CA Certs Mismatch
                </Typography>
            </Grid>


            <Grid container>

                <Grid item xs={12}>
                    <Card square={true}>
                        <CardContent divider={'FuelDivider'}>
                            <Grid container mt={"10px"}>
                                <Grid item xs={12}>
                                    <div style={{textAlign: "right"}}>

                                        <Box p="0.25rem">
                                            <FormControlLabel
                                                control={<Switch name="showNotMatching"/>}
                                                label="Show Not Matching Only"
                                                labelPlacement={"start"}
                                                onChange={onChangeShowNotMatching}
                                            />
                                        </Box>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography gutterBottom variant="h2" component="h1">
                                        Total CA Certs: {filteredCaCertProfiles.length}
                                    </Typography>
                                </Grid>
                            </Grid>
                        {


                            filteredCaCertProfiles.map((profile, index) => {
                                const iconStatus = profile.matching === true ?
                                    <CheckCircle fontSize="small"  sx={{color: "success", mr: 1}}/> :
                                    <Warning fontSize="small" sx={{color: "red", mr: 1}}/>;


                                profile["expirationDays"]=getDiffDays(new Date(),profile.notAfterDate);
                                profile.remoteCaCert["expirationDays"]=profile.remoteCaCert.found ? getDiffDays(new Date(),profile.remoteCaCert.notAfterDate) : null;

                                profile["expirationLabel"]=getExpirationLabel(profile.expirationDays);
                                profile.remoteCaCert["expirationLabel"]=getExpirationLabel(profile.remoteCaCert.expirationDays);

                                return (
                                    <Grid container mt={"10px"} key={profile.certName}>
                                        <Grid item xs={12}>
                                            <Accordion sx={{borderRadius: "0rem"}}>

                                                    <AccordionSummary>
                                                       {`${profile.protocol}://${profile.hostname}:${profile.port}`}
                                                        <Box
                                                            className="end-content"
                                                            aria-label="status-information"
                                                            sx={(theme) => ({
                                                                flexGrow: 1,
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "flex-end",
                                                                [theme.breakpoints.down("sm")]: {
                                                                    flexGrow: "0",
                                                                    marginLeft: "0.5rem",
                                                                },
                                                            })}
                                                        >
                                                            {iconStatus}
                                                            <Typography
                                                                variant="body2">{profile.matching === true ? "Cert in Sterling Matching Remote Cert" : "Cert in Sterling Not Matching Remote Cert"}</Typography>
                                                        </Box>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Grid container mb={"10px"}>
                                                            <Grid item xs={4}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Sterling CA Cert</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "center"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Valid From</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.goLiveDate}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Valid To</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.notAfterDate}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "self-end"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Expiration in Days</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.expirationDays}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "center"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Status</InputLabel>
                                                                    <RenderStatus value={profile.expirationLabel}/>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container mb={"10px"}>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Remote CA Cert</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Status</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.remoteCaCert.found ? "Cert Available": "Cert Not Available"}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "center"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Valid From</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.remoteCaCert.goLiveDate}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Valid To</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.remoteCaCert.notAfterDate}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "self-end"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Expiration in Days</InputLabel>
                                                                    <Typography size="sm" component="p" gutterBottom>
                                                                        {profile.remoteCaCert.expirationDays}
                                                                    </Typography>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <FormControl fullWidth sx={{alignItems: "center"}}>
                                                                    <InputLabel style={{fontWeight: "bold", fontSize: "small"}}>Status</InputLabel>
                                                                    <RenderStatus value={profile.remoteCaCert.expirationLabel}/>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>
                                );
                            })

                        }

                    </CardContent>
                </Card>
            </Grid>
        </Grid>
        </Grid>

    );
}

export default As2TradePartnersMismatchCACerts;
